import * as $runtime from "../runtime.js";
import * as Control$dBind from "../Control.Bind/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dMultiSet from "../Data.MultiSet/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dSemiring from "../Data.Semiring/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Restaumatic$dCart$dDetail from "../Restaumatic.Cart.Detail/index.js";
import * as Restaumatic$dCart$dExtraDiscount from "../Restaumatic.Cart.ExtraDiscount/index.js";
import * as Restaumatic$dCart$dPricing from "../Restaumatic.Cart.Pricing/index.js";
import * as Restaumatic$dCart$dProductItem from "../Restaumatic.Cart.ProductItem/index.js";
import * as Restaumatic$dCart$dProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic$dCart$dPromotionData from "../Restaumatic.Cart.PromotionData/index.js";
import * as Restaumatic$dCart$dPromotionalItem from "../Restaumatic.Cart.PromotionalItem/index.js";
import * as Restaumatic$dMenu$dQuery from "../Restaumatic.Menu.Query/index.js";
import * as Restaumatic$dMenu$dV2$dEnv from "../Restaumatic.Menu.V2.Env/index.js";
import * as Restaumatic$dMenu$dV2$dPackaging from "../Restaumatic.Menu.V2.Packaging/index.js";
import * as Restaumatic$dMenu$dV2$dPackaging$dMinNumberOfContainersHeuristicAlgo from "../Restaumatic.Menu.V2.Packaging.MinNumberOfContainersHeuristicAlgo/index.js";
import * as Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount from "../Restaumatic.Orders.Checkout.Types.ExtraDiscount/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dCartData from "../Restaumatic.PromotionsEngine.Cart.CartData/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dCartParams from "../Restaumatic.PromotionsEngine.Cart.CartParams/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic$dPromotionsEngine$dCart$dPromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
import * as Restaumatic$dPromotionsEngine$dTools$dAssignment from "../Restaumatic.PromotionsEngine.Tools.Assignment/index.js";
import * as Restaumatic$dPromotionsEngine$dTools$dCartEvaluation from "../Restaumatic.PromotionsEngine.Tools.CartEvaluation/index.js";
import * as Restaumatic$dPromotionsEngine$dTools$dDistribution from "../Restaumatic.PromotionsEngine.Tools.Distribution/index.js";
import * as Restaumatic$dPromotionsEngine$dTools$dFilter from "../Restaumatic.PromotionsEngine.Tools.Filter/index.js";
import * as Restaumatic$dPromotionsEngine$dTools$dPromotionEvaluation from "../Restaumatic.PromotionsEngine.Tools.PromotionEvaluation/index.js";
import * as Restaumatic$dPromotionsEngine$dTools$dUserAction from "../Restaumatic.PromotionsEngine.Tools.UserAction/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const $Action = (tag, _1, _2, _3) => ({tag, _1, _2, _3});
const $InsertPosition = tag => ({tag});
const $PromotionScope = tag => ({tag});
const $Selling = tag => ({tag});
const evaluateEnabledPromotionalItems = /* #__PURE__ */ Restaumatic$dPromotionsEngine$dTools$dPromotionEvaluation.evaluateEnabledPromotionalItems(Restaumatic$dCart$dProductKey.eqProductKey);
const sum1 = /* #__PURE__ */ (() => Data$dFoldable.foldlArray(Data$dMoney$dRounded.additiveMoney.add)(0))();
const toUnfoldable = /* #__PURE__ */ (() => {
  const $0 = Data$dUnfoldable.unfoldableArray.unfoldr(Data$dMap$dInternal.stepUnfoldr);
  return x => $0(Data$dMap$dInternal.$MapIter("IterNode", x, Data$dMap$dInternal.IterLeaf));
})();
const identity = x => x;
const fold = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(Data$dMonoid.monoidArray)(Data$dFoldable.identity))();
const sum2 = /* #__PURE__ */ Data$dFoldable.foldlArray(Data$dSemiring.intAdd)(0);
const any = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap((() => {
  const semigroupDisj1 = {append: v => v1 => v || v1};
  return {mempty: false, Semigroup0: () => semigroupDisj1};
})()))();
const maybeEnablePromotionalItem$p = /* #__PURE__ */ Restaumatic$dPromotionsEngine$dTools$dUserAction.maybeEnablePromotionalItem$p(Restaumatic$dCart$dProductKey.ordProductKey);
const unassign = /* #__PURE__ */ Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.unassign(Restaumatic$dCart$dProductKey.ordProductKey);
const distributePromotions = /* #__PURE__ */ Restaumatic$dPromotionsEngine$dTools$dDistribution.distributePromotions(Restaumatic$dCart$dProductKey.ordProductKey);
const min = x => y => {
  const v = Data$dOrd.ordInt.compare(x)(y);
  if (v.tag === "LT") { return x; }
  if (v.tag === "EQ") { return x; }
  if (v.tag === "GT") { return y; }
  $runtime.fail();
};
const assignPromotionalItems = /* #__PURE__ */ Restaumatic$dPromotionsEngine$dTools$dAssignment.assignPromotionalItems(Restaumatic$dCart$dProductKey.ordProductKey);
const enablePromotionalItemAndRecalculate = /* #__PURE__ */ Restaumatic$dPromotionsEngine$dTools$dUserAction.enablePromotionalItemAndRecalculate(Restaumatic$dCart$dProductKey.ordProductKey);
const disablePromotionalItemAndRecalculate = /* #__PURE__ */ Restaumatic$dPromotionsEngine$dTools$dUserAction.disablePromotionalItemAndRecalculate(Restaumatic$dCart$dProductKey.ordProductKey);
const disablePromotionalItemAndEvaluate = /* #__PURE__ */ Restaumatic$dPromotionsEngine$dTools$dUserAction.disablePromotionalItemAndEvaluate(Restaumatic$dCart$dProductKey.ordProductKey);
const CrossSelling = /* #__PURE__ */ $Selling("CrossSelling");
const NormalSelling = /* #__PURE__ */ $Selling("NormalSelling");
const Restaurant = /* #__PURE__ */ $PromotionScope("Restaurant");
const Restaumatic = /* #__PURE__ */ $PromotionScope("Restaumatic");
const First = /* #__PURE__ */ $InsertPosition("First");
const Last = /* #__PURE__ */ $InsertPosition("Last");
const Cart = x => x;
const ModifyQuantity = value0 => value1 => $Action("ModifyQuantity", value0, value1);
const ModifyQuantityUnlimited = value0 => value1 => value2 => $Action("ModifyQuantityUnlimited", value0, value1, value2);
const ReplaceItem = value0 => value1 => $Action("ReplaceItem", value0, value1);
const SetPromotionalItemSelected = value0 => value1 => $Action("SetPromotionalItemSelected", value0, value1);
const ChangePromotionalItemInput = value0 => value1 => $Action("ChangePromotionalItemInput", value0, value1);
const DisablePromotionalItemSelection = value0 => $Action("DisablePromotionalItemSelection", value0);
const ModifyCouponCode = value0 => $Action("ModifyCouponCode", value0);
const RecalculatePromotions = /* #__PURE__ */ $Action("RecalculatePromotions");
const RecalculateProductDetails = /* #__PURE__ */ $Action("RecalculateProductDetails");
const toPromotionalItems = menu => cartData => items => Data$dArray.mapMaybe(item => {
  const id = item.promotion.promotionId;
  const $0 = Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dMenu$dQuery.findPromotion(id))(promotion => Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dCart$dPromotionData.promotionDetails(id))(details => Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure({
    engineItem: item,
    details,
    promotion
  })))(menu);
  if ($0.tag === "Left") { return Data$dMaybe.Nothing; }
  if ($0.tag === "Right") { return Data$dMaybe.$Maybe("Just", $0._1); }
  $runtime.fail();
})(evaluateEnabledPromotionalItems(cartData)(items));
const takeByKey = dictOrd => k => acc => {
  const $0 = Data$dMap$dInternal.lookup(dictOrd)(k)(acc);
  if ($0.tag === "Just") {
    const $1 = Data$dArray.unconsImpl(v => Data$dMaybe.Nothing, x => xs => Data$dMaybe.$Maybe("Just", {head: x, tail: xs}), $0._1);
    if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", {value: $1._1.head, accum: Data$dMap$dInternal.insert(dictOrd)(k)($1._1.tail)(acc)}); }
    if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
    $runtime.fail();
  }
  if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
  $runtime.fail();
};
const setExtraDiscount = d => v => ({...v, extraDiscount: d});
const promotionsEngineItem = v => v.engineItem;
const promotionalItems = v => v.promotionalItems;
const promotionsTotal = predicate => {
  const $0 = Data$dFunctor.arrayMap(Restaumatic$dCart$dPromotionalItem.promotionalItemPrice);
  const $1 = Data$dArray.filter(item => predicate(item.promotion));
  return x => sum1($0($1(x.promotionalItems)));
};
const productItems = v => v.products;
const toInputCartData = assignmentMode => cart => (
  {
    productItems: Control$dBind.arrayBind(cart.products)(v => {
      if (v.unitPrice.tag === "Just") {
        return Restaumatic$dPromotionsEngine$dCart$dProductItem.mkProductItems({
          productName: "",
          productPrice: v.unitPrice._1,
          productId: (() => {
            if (v.key.tag === "CustomProduct") { return Restaumatic$dPromotionsEngine$dCart$dProductItem.mkGenericProductId; }
            if (v.key.tag === "MenuProduct") { return Restaumatic$dPromotionsEngine$dCart$dProductItem.mkGenericProductId; }
            if (v.key.tag === "MenuCombo") { return Restaumatic$dPromotionsEngine$dCart$dProductItem.mkGenericProductId; }
            $runtime.fail();
          })(),
          productCategoryId: (() => {
            if (v.details.tag === "Just") {
              if (v.details._1.tag === "MenuProductDetails") { return Data$dMaybe.$Maybe("Just", v.details._1._1.productCategoryId); }
              return Data$dMaybe.Nothing;
            }
            return Data$dMaybe.Nothing;
          })(),
          itemId: (() => {
            if (v.details.tag === "Just") {
              if (v.details._1.tag === "MenuProductDetails") { return Data$dMaybe.$Maybe("Just", v.details._1._1.itemId); }
              if (v.details._1.tag === "MenuComboDetails") {
                const v1 = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, v.details._1._1, 0);
                if (v1.tag === "Just") { return Data$dMaybe.$Maybe("Just", v1._1.itemId); }
                return Data$dMaybe.Nothing;
              }
              return Data$dMaybe.Nothing;
            }
            return Data$dMaybe.Nothing;
          })(),
          customParameters: (() => {
            if (v.details.tag === "Just") {
              if (v.details._1.tag === "MenuProductDetails") { return v.details._1._1.customParametersMap; }
              return Data$dMap$dInternal.Leaf;
            }
            return Data$dMap$dInternal.Leaf;
          })(),
          isCombo: v.details.tag === "Just" ? v.details._1.tag === "MenuComboDetails" : false
        })(v.key)(v.quantity);
      }
      if (v.unitPrice.tag === "Nothing") { return []; }
      $runtime.fail();
    }),
    orderType: Restaumatic$dPromotionsEngine$dCart$dCartParams.Delivery,
    deliveryZone: 1,
    requestedTime: Restaumatic$dPromotionsEngine$dCart$dCartParams.Asap,
    assignmentMode
  }
);
const packageProductItems = menu => items => {
  const combosCatalogue = menu.catalogue.combos;
  return Restaumatic$dMenu$dV2$dPackaging.computePackagingContainers(menu.catalogue.categories)(menu.catalogue.packagingContainers)(menu.catalogue.products)(menu.catalogue.modifiers)(dictOrd => Restaumatic$dMenu$dV2$dPackaging$dMinNumberOfContainersHeuristicAlgo.minNumberOfContainersHeuristic(dictOrd))(Control$dBind.arrayBind(items)(v => {
    if (v.key.tag === "MenuProduct") {
      return Data$dArray.replicateImpl(
        v.quantity,
        (() => {
          const $0 = v.key._1.modifiers;
          const productsAndModifiers = Data$dFunctor.arrayMap(v1 => Data$dTuple.$Tuple(
            v1.productId,
            Control$dBind.arrayBind(toUnfoldable(Data$dMap$dInternal.functorMap.map(Unsafe$dCoerce.unsafeCoerce)(Data$dMap$dInternal.unsafeUnionWith(
              Data$dOrd.ordString.compare,
              Data$dFunction.const,
              v1.modifiers,
              $0
            ))))(v1$1 => {
              const $1 = v1$1._1;
              return Data$dFunctor.arrayMap(modItemId => ({modifier: $1, modifierItem: modItemId}))(Data$dMultiSet.elems(v1$1._2));
            })
          ))(Data$dArray.toUnfoldable(Data$dUnfoldable.unfoldableArray)(v.key._1.parts));
          return {products: Data$dFunctor.arrayMap(Data$dTuple.fst)(productsAndModifiers), modifiers: fold(Data$dFunctor.arrayMap(Data$dTuple.snd)(productsAndModifiers))};
        })()
      );
    }
    if (v.key.tag === "MenuCombo") {
      const $0 = v.key._1.comboId;
      const $1 = Data$dFunctor.arrayMap(v3 => Data$dTuple.$Tuple(
        Control$dBind.arrayBind(toUnfoldable(Data$dMap$dInternal.functorMap.map(Unsafe$dCoerce.unsafeCoerce)(v3._2.modifiers)))(v5 => {
          const $1 = v5._1;
          return Data$dFunctor.arrayMap(modItemId => ({modifier: $1, modifierItem: modItemId}))(Data$dMultiSet.elems(v5._2));
        }),
        (() => {
          const $1 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)($0)(combosCatalogue);
          const $2 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v3._1);
          const $3 = (() => {
            if ($1.tag === "Just") { return $2($1._1.elements._1); }
            if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
            $runtime.fail();
          })();
          const $4 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v3._2.comboChoiceId);
          const $5 = (() => {
            if ($3.tag === "Just") { return $4($3._1.choices._1); }
            if ($3.tag === "Nothing") { return Data$dMaybe.Nothing; }
            $runtime.fail();
          })();
          if ($5.tag === "Just") { return Data$dMaybe.$Maybe("Just", $5._1.product); }
          return Data$dMaybe.Nothing;
        })()
      ))(toUnfoldable(v.key._1.elements));
      return Data$dArray.replicateImpl(
        v.quantity,
        {products: Data$dArray.mapMaybe(identity)(Data$dFunctor.arrayMap(Data$dTuple.snd)($1)), modifiers: Control$dBind.arrayBind($1)(Data$dTuple.fst)}
      );
    }
    return [];
  }));
};
const normalizeProductKey = key => Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure(key);
const newtypeCart = {Coercible0: () => {}};
const toPackagingAssignment = cart => Data$dFunctor.arrayMap(v => Data$dTuple$dT2.$T2(v._1, Data$dFunctor.arrayMap(v1 => v1.containedId)(v._2)))(cart.packagingContainers);
const toPackagingContainersCost = cart => cart.packagingContainersCost;
const makeProductItem = menuEnv => v => quantity => {
  const $0 = v.note;
  return Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure(v.key))(key => Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dCart$dPricing.productPrice(menuEnv)(key))(v1 => {
    const $1 = v1.errors;
    const $2 = v1.price;
    return Restaumatic$dMenu$dQuery.bindMenuQuery.bind(Restaumatic$dCart$dDetail.productDetails(menuEnv)(key))(details => Restaumatic$dMenu$dQuery.applicativeMenuQuery.pure({
      key,
      unitPrice: $2,
      details: Data$dMaybe.$Maybe("Just", details),
      errors: $1,
      quantity,
      note: $0
    }));
  }));
};
const lookupQuantity = needle => {
  const $0 = Data$dFoldable.foldlArray(v => v1 => {
    if (v.tag === "Nothing") {
      if (
        Restaumatic$dCart$dProductKey.eqProductKey.eq(v1.key)(needle.key) && (() => {
          if (v1.note.tag === "Nothing") { return needle.note.tag === "Nothing"; }
          if (v1.note.tag === "Just") {
            if (needle.note.tag === "Just") { return v1.note._1 === needle.note._1; }
            return false;
          }
          return false;
        })()
      ) {
        return Data$dMaybe.$Maybe("Just", v1.quantity);
      }
      return Data$dMaybe.Nothing;
    }
    return v;
  })(Data$dMaybe.Nothing);
  return x => {
    const $1 = $0(x);
    if ($1.tag === "Nothing") { return 0; }
    if ($1.tag === "Just") { return $1._1; }
    $runtime.fail();
  };
};
const lookupProduct = needle => Data$dFoldable.foldlArray(v => v1 => {
  if (v.tag === "Nothing") {
    if (Restaumatic$dCart$dProductKey.eqProductKey.eq(v1.key)(needle)) { return Data$dMaybe.$Maybe("Just", v1); }
    return Data$dMaybe.Nothing;
  }
  return v;
})(Data$dMaybe.Nothing);
const itemCount = v => sum2(Data$dFunctor.arrayMap(x => x.quantity)(v.products));
const isEmpty = v => v.products.length === 0;
const hasSelectedPromotion = v => predicate => any(item => predicate(item) && (item.engineItem.selection.tag === "UserEnabled" || item.engineItem.selection.tag === "AutoEnabled"))(v.promotionalItems);
const hasNoErrors = /* #__PURE__ */ (() => {
  const $0 = Data$dFoldable.foldableArray.foldMap((() => {
    const semigroupConj1 = {append: v => v1 => v && v1};
    return {mempty: true, Semigroup0: () => semigroupConj1};
  })())(Restaumatic$dCart$dProductItem.hasNoProductErrors);
  return x => $0(x.products);
})();
const groupBy = dictOrd => keyFn => {
  const $0 = Data$dMap$dInternal.fromFoldableWith(dictOrd)(Data$dFoldable.foldableArray)(b => a => Data$dSemigroup.concatArray(a)(b));
  const $1 = Data$dFunctor.arrayMap(x => Data$dTuple.$Tuple(keyFn(x), [x]));
  return x => $0($1(x));
};
const groupedRightZipWith = dictOrd => keyA => keyB => fn => as => {
  const $0 = Data$dFoldable.foldlArray(v => b => {
    const v1 = takeByKey(dictOrd)(keyB(b))(v._1);
    if (v1.tag === "Nothing") { return Data$dTuple.$Tuple(v._1, Data$dArray.snoc(v._2)(fn(Data$dMaybe.Nothing)(v._2)(b))); }
    if (v1.tag === "Just") { return Data$dTuple.$Tuple(v1._1.accum, Data$dArray.snoc(v._2)(fn(Data$dMaybe.$Maybe("Just", v1._1.value))(v._2)(b))); }
    $runtime.fail();
  })(Data$dTuple.$Tuple(groupBy(dictOrd)(keyA)(as), []));
  return x => $0(x)._2;
};
const restoreSelections = /* #__PURE__ */ groupedRightZipWith(Data$dOrd.ordInt)(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.promotionId)(Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.promotionId)(v => v1 => v2 => {
  if (v.tag === "Just") {
    const newItem1 = {...v2, input: v._1.input};
    if (v._1.selection.tag === "UserEnabled") {
      const $0 = maybeEnablePromotionalItem$p(v1)(newItem1);
      if ($0.tag === "Nothing") { return newItem1; }
      if ($0.tag === "Just") { return $0._1; }
      $runtime.fail();
    }
    if (v._1.selection.tag === "UserDisabled") { return {...unassign(newItem1), selection: Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.UserDisabled}; }
    return newItem1;
  }
  if (v.tag === "Nothing") {
    if (
      (() => {
        if (v2.promotion.promotionType.tag === "Standard") { return false; }
        if (v2.promotion.promotionType.tag === "InformationOnly") { return false; }
        return v2.promotion.promotionType.tag === "RequiresCoupon";
      })()
    ) {
      const $0 = maybeEnablePromotionalItem$p(v1)(v2);
      if ($0.tag === "Nothing") { return v2; }
      if ($0.tag === "Just") { return $0._1; }
      $runtime.fail();
    }
    return v2;
  }
  $runtime.fail();
});
const genericCart = {to: x => x, from: x => x};
const showCart = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dCart$dPromotionalItem.showPromotionalItem.show);
      const $1 = Data$dShow.showArrayImpl(Restaumatic$dCart$dProductItem.showProductItem.show);
      const $2 = Data$dShow.showArrayImpl(Restaumatic$dMenu$dV2$dPackaging.showContained(Data$dUUID.showUUID).show);
      const $3 = Data$dShow.showArrayImpl(v => "(Tuple " + v._1 + " " + $2(v._2) + ")");
      const $4 = (v, record) => " packagingContainers: " + $3(record.packagingContainers) + ", packagingContainersCost: " + Data$dMoney$dRounded.toString(record.packagingContainersCost) + ", products: " + $1(record.products) + ", promotionalItems: " + $0(record.promotionalItems) + " ";
      return {
        genericShowArgs: v => [
          (() => {
            if (v.couponCode.tag === "Just") {
              return "{ couponCode: (Just " + Data$dShow.showStringImpl(v.couponCode._1) + ")" + (() => {
                if (v.extraDiscount.tag === "Just") {
                  return ", extraDiscount: (Just " + Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount.showExtraDiscount.show(v.extraDiscount._1) + ")" + "," + $4(
                    Type$dProxy.Proxy,
                    v
                  );
                }
                if (v.extraDiscount.tag === "Nothing") { return ", extraDiscount: Nothing," + $4(Type$dProxy.Proxy, v); }
                $runtime.fail();
              })() + "}";
            }
            if (v.couponCode.tag === "Nothing") {
              if (v.extraDiscount.tag === "Just") {
                return "{ couponCode: Nothing, extraDiscount: (Just " + Restaumatic$dOrders$dCheckout$dTypes$dExtraDiscount.showExtraDiscount.show(v.extraDiscount._1) + ")" + "," + $4(
                  Type$dProxy.Proxy,
                  v
                ) + "}";
              }
              if (v.extraDiscount.tag === "Nothing") { return "{ couponCode: Nothing, extraDiscount: Nothing," + $4(Type$dProxy.Proxy, v) + "}"; }
              $runtime.fail();
            }
            $runtime.fail();
          })()
        ]
      };
    })())({reflectSymbol: () => "Cart"});
    return x => $0["genericShow'"](x);
  })()
};
const extraDiscount = v => v.extraDiscount;
const eqPromotionScope = {
  eq: x => y => {
    if (x.tag === "Restaurant") { return y.tag === "Restaurant"; }
    if (x.tag === "Restaumatic") { return y.tag === "Restaumatic"; }
    return false;
  }
};
const totalAfterPromotions = promotionScope => cart => sum1(Data$dFunctor.arrayMap(x => {
  if (x.unitPrice.tag === "Just") { return x.quantity * x.unitPrice._1 | 0; }
  return 0;
})(cart.products)) + promotionsTotal((() => {
  if (promotionScope.tag === "Restaurant") { return v => true; }
  if (promotionScope.tag === "Restaumatic") {
    return x => {
      const v = Data$dRecord.unsafeGet("groupId")(x);
      if (v.tag === "Just") { return false; }
      if (v.tag === "Nothing") { return true; }
      $runtime.fail();
    };
  }
  $runtime.fail();
})())(cart) | 0;
const extraDiscountDetails = promotionScope => cart => {
  if (cart.extraDiscount.tag === "Just") {
    return Data$dMaybe.$Maybe("Just", Restaumatic$dCart$dExtraDiscount.toDetails(cart.extraDiscount._1)({totalAfterPromotions: totalAfterPromotions(promotionScope)(cart)}));
  }
  return Data$dMaybe.Nothing;
};
const emptyItems = v => ({...v, products: [], promotionalItems: []});
const empty = {products: [], promotionalItems: [], couponCode: Data$dMaybe.Nothing, extraDiscount: Data$dMaybe.Nothing, packagingContainers: [], packagingContainersCost: 0};
const distinctProductItems = productItems;
const couponCode = v => v.couponCode;
const canOrder = x => x.products.length !== 0;
const baseRestaurantTotal = cart => {
  const $0 = extraDiscountDetails(Restaumatic)(cart);
  return totalAfterPromotions(Restaumatic)(cart) - (() => {
    if ($0.tag === "Nothing") { return 0; }
    if ($0.tag === "Just") { return $0._1.value; }
    $runtime.fail();
  })() | 0;
};
const baseCustomerTotal = cart => {
  const $0 = extraDiscountDetails(Restaurant)(cart);
  return totalAfterPromotions(Restaurant)(cart) - (() => {
    if ($0.tag === "Nothing") { return 0; }
    if ($0.tag === "Just") { return $0._1.value; }
    $runtime.fail();
  })() | 0;
};
const applyPromotions = mFulfillmentMethod => mPaymentMethod => assignmentMode => menu => assignPromotions$p => cart => {
  if (cart.products.length === 0) { return {...cart, products: [], promotionalItems: []}; }
  const cartData = toInputCartData(assignmentMode)(cart);
  return {
    ...cart,
    promotionalItems: toPromotionalItems(menu)(cartData)((() => {
      const $0 = assignPromotions$p(cartData)(distributePromotions(cartData)(Restaumatic$dPromotionsEngine$dTools$dFilter.filterPromotions(cartData)(Restaumatic$dCart$dPromotionData.enginePromotions(menu)(mFulfillmentMethod)(mPaymentMethod))));
      return Data$dFoldable.foldlArray(Restaumatic$dPromotionsEngine$dTools$dCartEvaluation.applyPromotionalItem)(Restaumatic$dPromotionsEngine$dCart$dCartData.mkDefaultOutputCartData(cartData)($0))($0).promotionalItems;
    })())
  };
};
const fromProductItems = mFulfillmentMethod => mPaymentMethod => assignmentMode => menu => assignPromotions$p => items => couponCode1 => {
  const v = packageProductItems(menu)(items);
  return applyPromotions(mFulfillmentMethod)(mPaymentMethod)(assignmentMode)(menu)(assignPromotions$p)({
    products: items,
    promotionalItems: [],
    couponCode: couponCode1,
    extraDiscount: Data$dMaybe.Nothing,
    packagingContainers: v._1,
    packagingContainersCost: v._2
  });
};
const alterCount = f => insertPos => extendedKey => products => {
  if (lookupQuantity(extendedKey)(products) === 0) {
    const count = f(0);
    if (count > 0) {
      return (() => {
        if (insertPos.tag === "First") { return Data$dArray.cons; }
        if (insertPos.tag === "Last") { return b => a => Data$dArray.snoc(a)(b); }
        $runtime.fail();
      })()({key: extendedKey.key, unitPrice: Data$dMaybe.Nothing, errors: Data$dMaybe.Nothing, details: Data$dMaybe.Nothing, quantity: count, note: extendedKey.note})(products);
    }
    return products;
  }
  return Data$dArray.mapMaybe(v => {
    if (
      Restaumatic$dCart$dProductKey.eqProductKey.eq(v.key)(extendedKey.key) && (() => {
        if (v.note.tag === "Nothing") { return extendedKey.note.tag === "Nothing"; }
        if (v.note.tag === "Just") {
          if (extendedKey.note.tag === "Just") { return v.note._1 === extendedKey.note._1; }
          return false;
        }
        return false;
      })()
    ) {
      const newQuantity = f(v.quantity);
      if (newQuantity > 0) { return Data$dMaybe.$Maybe("Just", {...v, quantity: newQuantity}); }
      return Data$dMaybe.Nothing;
    }
    return Data$dMaybe.$Maybe("Just", v);
  })(products);
};
const alterKey = oldKey => newKey => products => {
  const v = lookupQuantity(newKey)(products);
  if (v === 0) {
    return Data$dFunctor.arrayMap(v$1 => {
      if (
        Restaumatic$dCart$dProductKey.eqProductKey.eq(v$1.key)(oldKey.key) && (() => {
          if (v$1.note.tag === "Nothing") { return oldKey.note.tag === "Nothing"; }
          if (v$1.note.tag === "Just") {
            if (oldKey.note.tag === "Just") { return v$1.note._1 === oldKey.note._1; }
            return false;
          }
          return false;
        })()
      ) {
        return {...v$1, key: newKey.key, note: newKey.note};
      }
      return v$1;
    })(products);
  }
  return alterCount(v1 => v1 + v | 0)(Last)(newKey)(alterCount(v$1 => 0)(Last)(oldKey)(products));
};
const applyActionWithAssignMode = assignmentMode => action => menu => menuEnv => cart => {
  const inputCartData = toInputCartData(assignmentMode)(cart);
  const engineItems = Data$dFunctor.arrayMap(promotionsEngineItem)(cart.promotionalItems);
  const doApplyPromotions = applyPromotions(Restaumatic$dMenu$dV2$dEnv.fulfillmentMethod(menuEnv))(Restaumatic$dMenu$dV2$dEnv.paymentMethod(menuEnv))(assignmentMode)(menu)(inputCartData$p => {
    const $0 = restoreSelections(engineItems);
    const $1 = assignPromotionalItems(inputCartData$p);
    return x => $1($0(x));
  });
  const doApplyMenu = v => (
    {
      ...v,
      products: Data$dArray.mapMaybe(x => x)(Data$dFunctor.arrayMap(x => {
        const $0 = makeProductItem(menuEnv)({key: x.key, note: x.note})(x.quantity)(menu);
        if ($0.tag === "Left") { return Data$dMaybe.Nothing; }
        if ($0.tag === "Right") { return Data$dMaybe.$Maybe("Just", $0._1); }
        $runtime.fail();
      })(v.products))
    }
  );
  if (action.tag === "ModifyQuantity") {
    const $0 = doApplyPromotions(doApplyMenu({...cart, products: alterCount(x => min(99)(action._2(x)))(First)(action._1)(cart.products)}));
    const v1 = packageProductItems(menu)($0.products);
    return {...$0, packagingContainers: v1._1, packagingContainersCost: v1._2};
  }
  if (action.tag === "ModifyQuantityUnlimited") {
    const $0 = doApplyPromotions(doApplyMenu({...cart, products: alterCount(action._2)(First)(action._1)(cart.products)}));
    const v1 = packageProductItems(menu)($0.products);
    return {...$0, packagingContainers: v1._1, packagingContainersCost: v1._2};
  }
  if (action.tag === "ReplaceItem") {
    const $0 = doApplyPromotions(doApplyMenu({...cart, products: alterKey(action._1)(action._2)(cart.products)}));
    const v1 = packageProductItems(menu)($0.products);
    return {...$0, packagingContainers: v1._1, packagingContainersCost: v1._2};
  }
  if (action.tag === "SetPromotionalItemSelected") {
    if (action._2) {
      return {...cart, promotionalItems: toPromotionalItems(menu)(inputCartData)(enablePromotionalItemAndRecalculate(inputCartData)(engineItems)(action._1.engineItem))};
    }
    if (!action._2) {
      return {...cart, promotionalItems: toPromotionalItems(menu)(inputCartData)(disablePromotionalItemAndRecalculate(inputCartData)(engineItems)(action._1.engineItem))};
    }
    $runtime.fail();
  }
  if (action.tag === "ChangePromotionalItemInput") {
    const $0 = Restaumatic$dPromotionsEngine$dCart$dPromotionalItem.changeInput(Restaumatic$dCart$dProductKey.eqProductKey)(action._1.engineItem)(action._2);
    return {
      ...cart,
      promotionalItems: toPromotionalItems(menu)(inputCartData)(Data$dFunctor.arrayMap(item => {
        if (item.promotionalItemId === $0.promotionalItemId) { return $0; }
        return item;
      })(engineItems))
    };
  }
  if (action.tag === "DisablePromotionalItemSelection") {
    return Data$dFoldable.foldlArray(cart$p => item => (
      {
        ...cart$p,
        promotionalItems: toPromotionalItems(menu)(inputCartData)(disablePromotionalItemAndEvaluate(toInputCartData(assignmentMode)(cart$p))(Data$dFunctor.arrayMap(promotionsEngineItem)(cart$p.promotionalItems))(item.engineItem))
      }
    ))(cart)(Data$dArray.filterImpl(action._1, cart.promotionalItems));
  }
  if (action.tag === "ModifyCouponCode") { return doApplyPromotions({...cart, couponCode: action._1}); }
  if (action.tag === "RecalculatePromotions") { return doApplyPromotions(cart); }
  if (action.tag === "RecalculateProductDetails") { return doApplyPromotions(doApplyMenu(cart)); }
  $runtime.fail();
};
const applyAction = /* #__PURE__ */ applyActionWithAssignMode(Restaumatic$dPromotionsEngine$dCart$dCartParams.AutoAssign);
const applyActionManualAssign = /* #__PURE__ */ applyActionWithAssignMode(Restaumatic$dPromotionsEngine$dCart$dCartParams.ManualAssign);
export {
  $Action,
  $InsertPosition,
  $PromotionScope,
  $Selling,
  Cart,
  ChangePromotionalItemInput,
  CrossSelling,
  DisablePromotionalItemSelection,
  First,
  Last,
  ModifyCouponCode,
  ModifyQuantity,
  ModifyQuantityUnlimited,
  NormalSelling,
  RecalculateProductDetails,
  RecalculatePromotions,
  ReplaceItem,
  Restaumatic,
  Restaurant,
  SetPromotionalItemSelected,
  alterCount,
  alterKey,
  any,
  applyAction,
  applyActionManualAssign,
  applyActionWithAssignMode,
  applyPromotions,
  assignPromotionalItems,
  baseCustomerTotal,
  baseRestaurantTotal,
  canOrder,
  couponCode,
  disablePromotionalItemAndEvaluate,
  disablePromotionalItemAndRecalculate,
  distinctProductItems,
  distributePromotions,
  empty,
  emptyItems,
  enablePromotionalItemAndRecalculate,
  eqPromotionScope,
  evaluateEnabledPromotionalItems,
  extraDiscount,
  extraDiscountDetails,
  fold,
  fromProductItems,
  genericCart,
  groupBy,
  groupedRightZipWith,
  hasNoErrors,
  hasSelectedPromotion,
  identity,
  isEmpty,
  itemCount,
  lookupProduct,
  lookupQuantity,
  makeProductItem,
  maybeEnablePromotionalItem$p,
  min,
  newtypeCart,
  normalizeProductKey,
  packageProductItems,
  productItems,
  promotionalItems,
  promotionsEngineItem,
  promotionsTotal,
  restoreSelections,
  setExtraDiscount,
  showCart,
  sum1,
  sum2,
  takeByKey,
  toInputCartData,
  toPackagingAssignment,
  toPackagingContainersCost,
  toPromotionalItems,
  toUnfoldable,
  totalAfterPromotions,
  unassign
};
